import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'

export const Distance = withFacetContext(
    FacetName.distance,
    withFilterContext(FilterName.distance, SearchFiltersDropdown, {
        title: 'Distance',
        placeholder: 'National',
        ariaLabel: 'Distance',
    })
)
